// Which website page lists a post, by its category names. Mirrors the portal's
// src/utils/newsSections.js (ca-rootsfundme-portal), which picks the posts for
// each page by category id: /insights ("News & Insights") lists News and
// Insights; /events lists Events and Resources. Keep the two in step.
//
// Sufia's report, 2026-11-03: she chose "News" for a newsletter article and it
// was published on the Events page, because the editor never said where a
// category goes (and, until that date, News did go to Events).
const PAGE_BY_CATEGORY = {
  news: "News & Insights",
  insights: "News & Insights",
  events: "Events",
  resources: "Events",
};
const PAGE_ORDER = ["News & Insights", "Events"];

export function websitePagesFor(categoryNames) {
  const pages = new Set(
    (Array.isArray(categoryNames) ? categoryNames : [])
      .map((name) => PAGE_BY_CATEGORY[String(name || "").trim().toLowerCase()])
      .filter(Boolean)
  );
  return PAGE_ORDER.filter((page) => pages.has(page));
}

export function categoryPageHint(categoryNames) {
  const pages = websitePagesFor(categoryNames);
  if (!pages.length) return "News and Insights appear on the News & Insights page; Events and Resources on the Events page.";
  if (pages.length === 1) return `Appears on the website: ${pages[0]} page.`;
  return `Appears on the website: ${pages.join(" and ")} pages.`;
}
